export const affiliateTour = {
  key: "affiliate",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="affiliate-root"]',
      content: t("Tour_Affiliate_Root"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="affiliate-stats"]',
      content: t("Tour_Affiliate_Stats"),
      placement: "bottom",
    },
    {
      target: '[data-tour="affiliate-ref"]',
      content: t("Tour_Affiliate_Ref"),
      placement: "top",
    },
    {
      target: '[data-tour="affiliate-copy"]',
      content: t("Tour_Affiliate_Copy"),
      placement: "top",
    },
  ],
};
